module.exports = __webpack_public_path__ + "media/assets/icons/icon_fee-6e4abd0e876cb726005e7e4becab6319.svg";